import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { WidgetContainerComponent } from '@platform/dashboard/components/widget-container/widget-container.component';
import { DashboardComponentStore } from '@platform/dashboard/pages/dashboard/dashboard.store';
import { paths } from '@platform/paths';
import { AnalyticsService } from '@shared/services/analytics.service';
import { DialogService } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'cp-dashboard',
  imports: [CommonModule, SkeletonModule, WidgetContainerComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DashboardComponentStore, DialogService],
})
export class DashboardComponent implements OnInit {
  private readonly componentStore = inject(DashboardComponentStore);
  private readonly analytics = inject(AnalyticsService);

  protected readonly selectIsLoadingPortfolio$ = this.componentStore.selectIsLoadingPortfolio$;
  protected readonly dashboardWidgets$ = this.componentStore.selectDashboardWidgets$;
  protected readonly hasWidgetBetterDeal$ = this.componentStore.hasWidgetBetterDeal$;

  protected readonly paths = paths;

  ngOnInit(): void {
    this.hasWidgetBetterDeal$.subscribe((hasBD) => this.analytics.setBetterDealsAvailable(hasBD));
  }
}
